<template>
  <div id="Benefit">
    <div class="title">
      <p>煤炭企业管理现代化创新成果</p>
      <p>效 益 计 算 方 法</p>
    </div>
    <div class="content">
      <p
        class="duan1"
      >为规范煤炭企业管理现代化创新成果效益（简称成果效益）的计量口径和方法，便于界定、测算、汇总和比较，并通过成果效益的计算逐步把管理创新所创造的效益，从总体效益中分离并相对独立地量化出来，以展现管理也是重要生产力，进一步提升我国煤炭企业管理水平，特制定本计算方法。</p>
      <p
        class="duan1"
      >一、管理现代化创新成果所取得的效益，主要包括经济效益和社会效益两个部分。经济效益是指实施该项成果后产生的效益扣减实施该项成果所投入的费用而得出的效益。社会效益是指实施该项成果产生的生态效益、创造就业机会、支持公益事业、为推进我国煤炭企业管理现代化提供示范等。</p>
      <p class="duan1">二、成果效益必须是该成果所创造的直接效益。不能把非成果作用而产生的效益计入成果效益，也不能重复计算。成果效益必须是经过科学测算真实反映的成果效益量。</p>
      <p
        class="duan1"
      >三、本方法主要适用于成果经济效益的计算。凡能计算经济效益的成果，在申报时都应依据本方法进行计算；不能计算经济效益的成果，如成果效益主要体现在社会效益方面，可采用定性方法评价；如采用本计算方法难以表达成果效益，可根据其效益性原则另用别的公式测算，但申报时必须附详细资料。</p>
      <p class="duan1">四、成果经济效益主要计算方法</p>
      <p class="duan2">
        <b>1</b>. 单项因素直接测定法（按英语缩写为
        <b>MTP</b>）
      </p>
      <p class="duan2">
        “
        <b>MTP</b>”是成果实施后在成果效益计算年度内实测效益（效率）数据与该成果实施前一年度的实际或定额进行对比的差量，折算为价值量，再扣减成果实施所需费用后而得出的成果效益。
      </p>
      <p class="duan2">
        “
        <b>MTP</b>”只适用于能直接计算经济效益的单项成果，如节约投入材料项目的工、料、管理费、资金、工程费等；增加产出项目的产值、销售收入等；提高市场占有率项目的新增利润数等。
      </p>
      <!-- <p class="duan3">
      <b>
        E
        <span>m</span>=（Q1-Q0）r-(∑Ca + I )-F
      </b>
      <b>n</b>
      <b>a=1</b>
      </p>-->
      <div class="gongshi">
        <img src="../assets/ben/1.png" alt />
      </div>
      <p class="duan4">
        <b class="keyword">E</b>
        <sub>m</sub>：按“
        <b>MTP</b>”方法计算出的单项成果经济效益，以现行价格计算的价值量表示。
      </p>
      <p class="duan4">
        <b class="keyword">Q</b>
        <sub>1</sub>：按“
        <b>MTP</b>”方法计算出的单项成果经济效益，以现行价格计算的价值量表示。
      </p>
      <p class="duan4">
        <b class="keyword">Q</b>
        <sub>0</sub>：
        成果实施前一年度的实际数。
      </p>
      <p class="duan5">
        <b>Q</b>
        <sub>1</sub>-
        <b>Q</b>
        <sub>0</sub>：两者的差额。
        <b>Q</b>
        <sub>1</sub>、
        <b>Q</b>
        <sub>0</sub>：
        可以代表定额、标准、实测数等等；可以表现为绝对数、相对数。
        <b>Q</b>
        <sub>1</sub>-
        <b>Q</b>
        <sub>0</sub>：
        差量可能是劳动量或实物量或价值量，但最终必须换算为以现行价格计量的价值量。
      </p>
      <P>
        <b>r</b>为将非价值量
        <b>Q</b>换算成计算年度价值量所需的一系列换算用数乘积的总称。如
        <b>Q</b>是产品某原料的消耗定额时，
        <b>r</b>就等于计算年度的产品产量乘该原料的价格。
      </P>
      <div class="gongshi2">
        <img src="../assets/ben/2.png" alt />：所花的各种实施成果费用之和。
      </div>
      <p>
        <b>I</b>：实施成果损失费用。
      </p>
      <p>
        <b>F</b>：非本成果实施所产生的效益。
      </p>
      <p>
        <b>2</b>. 相关因素合成计算法（
        <b>PCP</b>
      </p>
      <p>
        “
        <b>PCP</b>”是按综合性成果的构成因素先分别计算出单项因素效益，然后再合成为总效益，并从中减去非本成果实施所产生的效益及实施费用和实施损失费用，即得成果创造的效益。
      </p>
      <p>
        “
        <b>PCP</b>适用于成果本身具有相关而又可分离的构成因素，并能按本身构成因素分别计算效益的综合性管理创新成果。
      </p>
      <p>
        “
        <b>PCP</b>的计算公式如下：
      </p>
      <div class="gongshi">
        <img src="../assets/ben/3.png" alt />
      </div>
      <p>
        <b>E</b>
        <sub>p</sub>：按“
        <b>PCP</b> ”计算的各相关多因素的合成效益，以现行价格计算的价值量表示。
      </p>
      <div class="gongshi2">
        <img src="../assets/ben/4.png" alt />：按单项因素直接测定法计算的各种因素的经济效益之和
      </div>
      <p>
        <b>F</b>：非本成果实施产生的效益。
      </p>
      <p>
        <b>H</b>：各因素之间重复计算的效益。
      </p>
      <div class="gongshi2">
        <img src="../assets/ben/5.png" alt />：在单因素计算中未包含各种综合性实施费用之和。
      </div>
      <p>
        <b>I</b>：在单因素计算中未包含的综合性损失费用。
      </p>
      <p>
        <b>3</b>. 复合因素分离计算法（
        <b>CSP</b>）
      </p>
      <p>
        “
        <b>CSP</b>”是在成果效益计算年度内，以成果实施后每年实现利润与成果实施前一年度完成利润差数为基数，逐项分离并相应扣减与本成果无关因素所创造的效益，得出每年成果效益，然后把成果实施后每年成果效益相加，最终得出成果总效益。这是一种总体利润按构成因素反算的计算法。计算公式一般由总效益差数、非本成果因素效益、成果实施费用等组成。
      </p>
      <p>
        “
        <b>CSP</b>”适用于不易看出构成因素的综合性管理创新成果效益的计算。这种综合性成果一般具有以下特点：成果作用的范围具有全局性，涉及总系统和大部分分系统，或涉及总体管理和大部分专项管理领域；成果的多种功能同时作用于某个管理对象；成果在时间和空间上具有交叉性，成果作用的时空界限很难在构成因素间作明确划分。
      </p>
      <p>
        “
        <b>CSP</b>”的计算公式如下：
      </p>
      <div class="gongshi xg">
        <img src="../assets/ben/10.png" alt />
      </div>
      <p>
        <b>E</b>
        <sub>c</sub>：以“
        <b>CSP</b>”方法计算出的综合管理成果效益，以实现利润表示。
      </p>
      <p>
        <b>P</b>
        <sub>1</sub>：成果实施后在成果效益计算年度内的总效益。
      </p>
      <p>
        <b>P</b>
        <sub>0</sub>：成果实施前一年度的总效益。
      </p>
      <p>
        <b>N</b>：未实施本成果时在正常年景下自然增长的经济效益。通常采用成果实施前三年（未实施本成果）的平均值。
      </p>
      <div class="gongshi2">
        <img src="../assets/ben/6.png" alt />：各项投入效益之和。投入效益是指新投入固定资产（包括基建、技改）而扩大生产能力或提高产品水平而取得的效益。
      </div>
      <div class="gongshi2">
        <img src="../assets/ben/7.png" alt />：各项外因效益之和。外因效益是指非企业生产经营活动，而是因企业外部条件而获取的效益。
      </div>
      <div class="gongshi2">
        <img src="../assets/ben/8.png" alt />：各项非管理效益之和。非管理效益是指非管理因素而获取的效益。
      </div>
      <div class="gongshi2">
        <img src="../assets/ben/9.png" alt />：成果实施所花的各项费用之和。
      </div>
      <p>
        <b>I</b>：实施成果损失费用。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Benefit"
};
</script>

<style lang="less" scoped>
#Benefit {
  width: 100%;
  min-width: 1000px;
  padding: 1.5rem 2rem 0;
  font-size: 0.2rem;
   .title {
      margin-bottom: 0.6rem;
      text-align: center;
      font-weight: 500;
      font-size: 0.36rem;
    }
  .content {
    border: 1px dashed #999;
    padding: 0.5rem 1rem 0.5rem;
    margin-bottom:.6rem ;
    .gongshi {
      width: 100%;
      text-align: center;
      margin: 0.3rem 0;
      img {
        width: 40%;
        height: 0.8rem;
      }
    }
    .xg {
      img {
        width: 45%;
        height: 1rem;
      }
    }
   
    .gongshi2 {
      height: 0.6rem;
      display: flex;
      align-items: center;
      padding-left: 0.3rem;
      margin-bottom: 0.2rem;
      img {
        width: 0.5rem;
        height: 100%;
      }
    }
    p {
      line-height: 0.3rem;
      text-indent: 2em;
      margin-bottom: 0.2rem;
    }
  }
}
</style>